import type { Station } from "@station/domain/models/station.model";
import type { StationRepository } from "@station/domain/repositories/station.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class StationAddSelectedUseCase {
    constructor(
        @inject(stationsTypes.repositories.StationRepository)
        private readonly stationRepository: StationRepository,
    ) {}

    execute(station: Readonly<Station> | Readonly<Station>[]): void {
        this.stationRepository.addStation(station);
    }
}
